import { closeModal } from '../common/modals';
import Cookies from 'js-cookie';

(() => {
    const $siteFooterBottomSpacer = document.querySelector('.site-footer-bottom-spacer');
    const $cookiesNotice = document.querySelector('.cookies-notice');
    const $cookiesModal = document.querySelector('.cookies-notice-options');
    const $acceptAllBtn = document.querySelector('.cookies-notice__accept-all-btn');
    const $rejectAllBtn = document.querySelector('.cookies-notice__reject-all-btn');
    const $cookiesForms = document.querySelectorAll('.cookies-notice-form');

    if (!$cookiesNotice) return;

    const siteFooterCookiesNoticePadding = () => {
        if (!$siteFooterBottomSpacer) return;

        $siteFooterBottomSpacer.style.paddingBottom = `${$cookiesNotice?.classList?.contains('cookies-notice--hide') ? 0 : $cookiesNotice?.clientHeight}px`;
    };

    const initAnalyticalCode = cookieConsent => {
        const cookieConsentAccepted = cookieConsent ? cookieConsent : (Cookies.get('cookieConsent') ? JSON.parse(Cookies.get('cookieConsent')) : false);

        if (!cookieConsentAccepted) return;

        const cookieConsentAcceptedFunctional = cookieConsentAccepted.functional;
        const cookieConsentAcceptedPerformance = cookieConsentAccepted.performance;
        const cookieConsentAcceptedAnalytical = cookieConsentAccepted.analytical;
        const cookieConsentAcceptedMarketing = cookieConsentAccepted.marketing;

        if (typeof functionalScripts !== 'undefined' && cookieConsentAcceptedFunctional) {
            functionalScripts();
        }

        if (typeof performanceScripts !== 'undefined' && cookieConsentAcceptedPerformance) {
            performanceScripts();
        }

        if (typeof analyticalScripts !== 'undefined' && cookieConsentAcceptedAnalytical) {
            analyticalScripts();
        }

        if (typeof marketingScripts !== 'undefined' && cookieConsentAcceptedMarketing) {
            marketingScripts();
        }
    }

    const acceptCookies = (allowNecessaryCookies, allowFunctionalCookies, allowPerformanceCookies, allowAnalyticalCookies, allowMarketingCookies) => {
        if (!allowNecessaryCookies) {
            Cookies.remove('cookieConsent');
            return;
        }

        Cookies.set('cookieConsent', JSON.stringify({ 
            necessary: allowNecessaryCookies ? true : false,
            functional: allowFunctionalCookies ? true : false,
            performance: allowPerformanceCookies ? true : false,
            marketing: allowMarketingCookies ? true : false,
            analytical: allowAnalyticalCookies ? true : false,
        }), { expires: 365 });

        $cookiesNotice.classList.add('cookies-notice--hide');

        initAnalyticalCode(allowAnalyticalCookies ? true : false);

        setTimeout(() => {
            $cookiesNotice.parentNode.removeChild($cookiesNotice);
        }, 500);
    };

    const displayCookieConsentNotice = () => {
        if (window.scrollY === 0) return;

        const cookieConsent = Cookies.get('cookieConsent') ? JSON.parse(Cookies.get('cookieConsent')) : null;

        if (!cookieConsent || !cookieConsent.necessary) {
            $cookiesNotice.classList.remove('cookies-notice--hide');
            siteFooterCookiesNoticePadding();
        }

        window.removeEventListener('scroll', displayCookieConsentNotice);
    };

    if ($acceptAllBtn) {
        $acceptAllBtn.addEventListener('click', () => {
            acceptCookies(true, true, true, true, true);

            siteFooterCookiesNoticePadding();
        });
    }

    if ($rejectAllBtn) {
        $rejectAllBtn.addEventListener('click', () => {
            acceptCookies(true, false, false);

            siteFooterCookiesNoticePadding();
        });
    }

    if ($cookiesForms) {
        $cookiesForms.forEach($cookiesForm => {
            $cookiesForm.addEventListener('submit', e => {
                e.preventDefault();

                const necessaryCookies = e.target.querySelector('input[name="necessary-cookies"]');
                const functionalCookies = e.target.querySelector('input[name="functional-cookies"]');
                const performanceCookies = e.target.querySelector('input[name="performance-cookies"]');
                const analyticalCookies = e.target.querySelector('input[name="analytical-cookies"]');
                const marketingCookies = e.target.querySelector('input[name="marketing-cookies"]');

                acceptCookies(necessaryCookies?.checked, functionalCookies?.checked, performanceCookies?.checked, analyticalCookies?.checked, marketingCookies?.checked);

                if ($cookiesModal) {
                    closeModal($cookiesModal);
                }

                siteFooterCookiesNoticePadding();
            });
        });
    }

    window.addEventListener('resize', () => {
        siteFooterCookiesNoticePadding();
    });

    window.addEventListener('scroll', displayCookieConsentNotice);

    initAnalyticalCode();
})();
